<template>
<div class="vliveRoster bgc">
    <vliveHeader></vliveHeader>
    <div class="padding-20">
        <div class="filters">
            <div class="search">
                <el-date-picker v-model="param.dateTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
                <el-input v-model.trim="param.name" placeholder="请输入姓名、昵称" class="condition" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
            <div class="add">
                <el-button @click="handleExport">导出数据</el-button>
            </div>
        </div>
        <div class="filters">
        </div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column prop="spackageName" label="微信头像">
                    <template slot-scope="scope">
                        <img :src="scope.row.logourl" alt="" v-if="scope.row.logourl">
                        <img :src="defaultCover" alt="" v-else>
                    </template>
                </el-table-column>
                <el-table-column prop="date" label="微信昵称"></el-table-column>
                <el-table-column prop="date" label="姓名"></el-table-column>
                <el-table-column prop="date" label="电话"></el-table-column>
                <el-table-column prop="name" label="性别">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.status | status" placement="top">
                            <div>
                                <span :class="status(scope.row.status)">.{{scope.row.status | status}}</span>
                                <i class="icon icon_warning"></i>
                            </div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="date" label="姓名"></el-table-column>
                <el-table-column prop="date" label="地区"></el-table-column>
                <el-table-column prop="date" label="观看终端"></el-table-column>
                <el-table-column prop="date" label="开始观看时间"></el-table-column>
                <el-table-column prop="date" label="直播观看时长"></el-table-column>
                <el-table-column prop="date" label="回放观看时间"></el-table-column>
            </el-table>
            <page :total="total" @getList="_getList" ref="page"></page>
        </div>
    </div>
    <vliveBatchExport ref="vliveBatchExport"></vliveBatchExport>
</div>
</template>

<script>
import Page from 'base/page/page'
import {getVliveRosterList, exportVliveRosterList} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
import VliveHeader from 'views/cms/vlive/components/vliveHeader'
import VliveBatchExport from 'views/cms/vlive/components/vliveBatchExport'
export default {
    name: 'vliveRoster',
    data() {
        return {
            defaultCover: require('@/common/images/other/default_cover.png'),
            typeList: [{code: 1, name: '1'}, {code: 2, name: '2'}, {code: 3, name: '3'}],
            total: 550,
            param: {
                kmcinnerid: this.$route.query.id ? this.$route.query.id : '', // id
                kmctype: '3',
                dateTime: '',
                beginDatetime: '',
                endDatetime: '',
                nickname: '',
                name: ''
            },
            tableData: []
        }
    },
    mounted() {
        this._getList()
    },
    methods: {
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        handleExport() {
            this.setLoading(true)
            this.param.beginDatetime = this.param.dateTime ? this.param.dateTime[0] : ''
            this.param.endDatetime = this.param.dateTime ? this.param.dateTime[1] : ''
            this.param.nickname = this.param.name
            exportVliveRosterList({
                data: Object.assign({}, this.page, this.param),
                success: data => {
                    this.tableData = data.data.content
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // handleSelectExport() {
        //     this.$refs.vliveBatchExport.openDialog()
        // },
        _getList() {
            this.setLoading(true)
            this.param.beginDatetime = this.param.dateTime ? this.param.dateTime[0] : ''
            this.param.endDatetime = this.param.dateTime ? this.param.dateTime[1] : ''
            this.param.nickname = this.param.name
            getVliveRosterList({
                data: Object.assign({}, this.page, this.param),
                success: data => {
                    this.tableData = data.data.content
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {
        status (value) {
            let cls = ''
            switch (value) {
            case 1: cls = '已上架'
                break
            case 2: cls = '已下架'
                break
            case 3: cls = '定时上架'
                break
            case 4: cls = '完结'
                break
            default:
                cls = '更新中'
            }
            return cls
        }
    },
    watch: {},
    computed: {
        status () {
            return function(value) {
                let cls = ''
                switch (value) {
                case 1: cls = 'doing'
                    break
                case 2: cls = 'success'
                    break
                case 3: cls = 'error'
                    break
                case 4: cls = 'complete'
                    break
                default:
                    cls = 'fail'
                }
                return cls
            }
        },
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page,
        VliveHeader,
        VliveBatchExport
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveRoster {
    .result-list{
        .el-table__row{
            height: 55px;
        }
        .imageText{
            .imageText-summary{
                label{
                    width: 36px;
                    height: 16px;
                    border-radius: 2px;
                    margin-right: 2px;
                    background: $bgcolor-orange;
                    font-size: $font-12;
                    display: inline-block;
                    text-align: center;
                    line-height: 16px;
                    color: $tcolor-white;
                }
                .share{
                    background: $bgcolor-green;
                }
            }
        }
        img{
            width: 30px;
            height: 30px;
            border-radius: 50%;
        }
        .icon{
            margin-left: 10px;
            width: 14px;
            height: 14px;
        }
    }
}
</style>
